module.exports = __webpack_public_path__ + "img/logo_text_en.e2212194.png";